
const PostDetailsStyles = (theme) => ({
	typography: {
		marginTop: 20,
		marginBottom: 10,
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit
	},
	media: {
		height: 240,
		backgroundSize: 'contain',
		marginTop: theme.spacing.unit * 2
	},
	icon: {
		float: 'right'
	},
	logo: {
		background: 'white',
		height: 32,
		width: 32,
		float: 'left',
		margin: theme.spacing.unit,
		opacity: 0.3
	},
	leftIcon: {
		marginRight: theme.spacing.unit
	}
});

export default PostDetailsStyles;
